module.exports = __webpack_public_path__ + "assets/english-flag.505cfa40.svg";